import { privateRequest } from '../../utils/apiRequest';

const getUserHistory = async () => {
  const response = await privateRequest.get(`/api/quota/get-user-requests`);
  return response;
};

const historyServices = { getUserHistory };

export default historyServices;
